const ALLOWED_API_ORIGINS = [
  'http://localhost:5001',
  'https://tinymgr-qa-dps.kone.com',
  'https://tinymgr-dps.kone.com',
];

function getApiBaseUrl() {
  const configured = process.env.REACT_APP_CARDBIT_API || 'http://localhost:5001/api/cardbit';
  try {
    const url = new URL(configured);
    if (!ALLOWED_API_ORIGINS.some((origin) => url.origin === origin)) {
      throw new Error(`API origin not in allowlist: ${url.origin}`);
    }
  } catch (e) {
    if (e.message.includes('allowlist')) throw e;
    throw new Error(`Invalid API URL: ${configured}`);
  }
  return configured;
}

const API_BASE_URL = getApiBaseUrl();

export const CardBitService = {
  /**
   * Analyze card bit data
   */
  analyzeCard: async (cardBits, formatName = null) => {
    const response = await fetch(`${API_BASE_URL}/analyze`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
      },
      body: JSON.stringify({ 
        cardBits,
        formatName 
      })
    });
    
    if (!response.ok) {
      throw new Error('Card analysis failed');
    }
    
    return response.json();
  },

  /**
   * Get available card formats
   */
  getFormats: async () => {
    const response = await fetch(`${API_BASE_URL}/formats`, {
      // force fresh fetch to avoid browser returning 304 Not Modified
      cache: 'no-store',
      headers: {
        'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
      }
    });

    if (response.status === 304) {
      // No body is returned with 304; treat as empty result (or implement cache fallback)
      return { success: true, formats: [] };
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch formats (${response.status})`);
    }

    return response.json();
  },

  /**
   * Generate configuration file
   */
  generateConfig: async (analysisData) => {
    const response = await fetch(`${API_BASE_URL}/generate-config`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
      },
      body: JSON.stringify({ analysis: analysisData })
    });
    
    if (!response.ok) {
      throw new Error('Config generation failed');
    }
    
    return response.json();
  }
};